<template>
  <div>
    <h1 class="text-center mb-3">E-takst</h1>
    <v-layout wrap>
      <v-flex xs12 class="mt-2">
        <v-card>
          <v-text-field box hide-details label="Adresse" v-model="address" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-card>
          <v-text-field box hide-details label="Boligtype" v-model="houseType.name" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-card>
          <v-text-field box hide-details label="Eierform" v-model="ownerType.name" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pr-sm-2 mt-5">
        <v-card>
          <v-text-field box hide-details label="BRA" v-model="size.bra" suffix="m2" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pl-sm-2 mt-5">
        <v-card>
          <v-text-field box hide-details label="BTA" v-model="size.bta" suffix="m2" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pr-sm-2 mt-2">
        <v-card>
          <v-text-field box hide-details label="P-rom" v-model="size.p" suffix="m2" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pl-sm-2 mt-2">
        <v-card>
          <v-text-field box hide-details label="Tomt" v-model="size.property" suffix="m2" disabled></v-text-field>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-5">
        <v-card>
          <v-card-text>
            <h4>Beliggenhet</h4>
            <v-slider
              v-model="stepValues.location"
              step="1"
              max="10"
              min="0"
              ticks
              :tick-labels="sliderOptions"
              tick-size="5"
              thumb-label="always"
            ></v-slider>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-5">
        <v-card>
          <v-card-text>
            <h4>Standard</h4>
            <v-slider
              v-model="stepValues.standard"
              step="1"
              max="10"
              min="0"
              ticks
              :tick-labels="sliderOptions"
              tick-size="5"
              thumb-label="always"
            ></v-slider>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-5">
        <v-card>
          <v-text-field
            box
            hide-details
            label="Verdivurdering"
            type="number"
            v-model="stepValues.value"
            suffix="NOK"
          ></v-text-field>
        </v-card>
      </v-flex>
      
    </v-layout>
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      sliderOptions: ["Dårlig", "", "", "", "", "Middels", "", "", "", "", "God"]
    };
  },
  computed: {
    address: {
      get() {
        if (this.protocol.saved_values.steps['inspection-property']) {
          return (
            this.protocol.saved_values.steps['inspection-property'].saved_values.address.street +
            " " +
            this.protocol.saved_values.steps['inspection-property'].saved_values.address.streetNr +
            ", " +
            this.protocol.saved_values.steps['inspection-property'].saved_values.address.zipcode +
            " " +
            this.protocol.saved_values.steps['inspection-property'].saved_values.address.city
          );
        }
        return "";
      }
    },
    houseType: {
      get() {
        if (this.protocol.saved_values.steps['inspection-basics']) {
          return this.protocol.saved_values.steps['inspection-basics'].saved_values.houseType;
        }
        return "";
      }
    },
    ownerType: {
      get() {
        if (this.protocol.saved_values.steps['inspection-basics']) {
          return this.protocol.saved_values.steps['inspection-basics'].saved_values.ownerType;
        }
        return "";
      }
    },
    size: {
      get() {
        if (this.protocol.saved_values.steps['inspection-property']) {
          return this.protocol.saved_values.steps['inspection-property'].saved_values.size;
        }
        return "";
      }
    }
  }
};
</script>
